export default __webpack_public_path__ + "media/zurb/img/icons/favicon/apple-touch-icon-76x76-0e77f7bee46d77d6e22e4c997ebf921e.png";